<template>
  <div class="magazine-articles">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SanitasMagazineCorporateArticles',
}
</script>

<style scoped>
.magazine-articles {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  &:empty {
    display: none;
  }
  sup {
    top: -0.2em !important;
  }
}
</style>
